import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useDataAuth } from '../../../hooks/useDataAuth';
import { getMenu } from '../../../redux/actions/menu';
import { useNotification } from '../../../hooks/useNotification';

import { useMenu } from '../../../hooks/useMenu';
import { getProperty, safeParseJSON } from '../../../utils/jsonValidator';
import { callApi } from '../../../services/api.service';

import { setSessionStateActionsPending } from '../../../redux/actions/sessionState';

export default function useManageHome() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const [{ menu }] = useMenu();

    const [configuration, setconfiguration] = useState(null);

    const NavigateAction = useCallback((action) => {
        const { config } = action.configuration;
        dispatch(setSessionStateActionsPending(action));
        navigate(config.path, { state: { config: config } });
    }, [dispatch, navigate])

    const getMenuId = useCallback(async (idMenu) => {
        const response = await callApi("user_select", "MENU_ID", { id_user_action: idMenu }, userSession.token, { findOne: 'true' })
        if (response.status === 200 && response?.data) {
            const cfg = { config: response.data };
            setconfiguration(cfg);
        }
    }, [userSession.token])

    useEffect(() => {
        dispatch(getMenu(userSession.token));//Quitar cuando se termine proceso de acciones pendientes.
        console.log('userSession ', userSession);
        if (userSession.pending_action) {
            const obj = JSON.parse(userSession.pending_action);
            sendNotification({
                msg: t('messages.pendingAction', { action: obj.action }),
                variant: 'info',
            });
            setTimeout(() => {
                NavigateAction(obj);
            }, 500);
        }
        else if (userSession?.additional_field && getProperty(safeParseJSON(userSession.additional_field), "home") !== null) {
            getMenuId(getProperty(safeParseJSON(userSession.additional_field), "home"));
        }
        else {
            navigate("/home");
        }
    }, [dispatch, navigate, userSession.token, userSession.pending_action, userSession.additional_field]);

    useEffect(() => {
        if (menu.length > 0 && !userSession?.additional_field) {
            const data = menu.find(p => p.menu === "Inicio")
            const cfg = { config: data };
            if (data) {
                setconfiguration(cfg);
            }
        }
    }, [menu])

    return ({
        configuration
    })
}
